import { render } from "./MultiChoice.vue?vue&type=template&id=1c6c3af5"
import script from "./MultiChoice.vue?vue&type=script&lang=js"
export * from "./MultiChoice.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\创奇\\问卷\\answer-h5-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__